export default {
	logonParamsMapping: {
		ChannelID: 'chnlID',
		HSBC_OHD_CHANNEL_COUNTRY_CODE: 'chnlCC',
		HSBC_OHD_CHANNEL_GROUP_MEMBER_ID: 'chnlGMC',
		HSBC_OHD_STAFF_ID: 'staffID',
		IPType: 'bizLine',
		IPID: 'custID',
		IPCC: 'custCC',
		IPGMC: 'custGMC',
		HSBC_OHD_CUSTOMER_TYPE: 'custType',
		launchLocale: 'locale',
		targetFunction: 'targetFunc',
		sourcePage: 'sourceFunc'
	},
	logonDefaultValue: {
		ChannelID: 'OHB',
		bizLine: 'ESG',
		launchLocale: 'en_US',
		targetFunction: 'esgHome',
		sourcePage: 'eforms',
		chnlCC: process.env.REACT_APP_CHANNEL_CODE,
		chnlGMC: process.env.REACT_APP_GROUPMEMBER_CODE,
		custType: 'EFOS'
	},
	P2G1:{
		CAM: 'CAM30',
		System: 'P2G'
	},
	BACKURL: 'backUrl',
	P2G_LOCALEConfig:{
		en_HK: 'en_US',
		zh_CN: 'zh_CN',
		zh_HK: 'zh_HK'
	},

	DSP_LOCALConfig: {
		en_HK: 'en-hk',
		zh_CN: 'zh-cn',
		zh_HK: 'zh-hk'
	},

	dspAnonymousJWTTokenHeaders : {
		'content-type': 'application/json',
		'cache-control': 'no-cache'
	}

};

